import { useLocation } from 'react-router-dom';

export default function useIsPrivate() {
  const location = useLocation();
  const pathname = location.pathname;

  return pathname.startsWith('/associati');
}
